import { render } from "./BaseInputV2.vue?vue&type=template&id=565b48ef&scoped=true"
import script from "./BaseInputV2.vue?vue&type=script&lang=js"
export * from "./BaseInputV2.vue?vue&type=script&lang=js"

import "./BaseInputV2.vue?vue&type=style&index=0&id=565b48ef&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565b48ef"]])

export default __exports__